import { toast } from 'sonner';

import { plainToastText } from '@/lib/errors/friendly-errors';

export function showErrorToast(message: string, description?: string) {
  const plain = plainToastText(message, description);
  toast.error(plain.message, { description: plain.description });
}

export function showSuccessToast(message: string, description?: string) {
  toast.success(message, { description });
}

export function showInfoToast(message: string, description?: string) {
  toast.info(message, { description });
}

export function showWarningToast(message: string, description?: string) {
  toast.warning(message, { description });
}

/**
 * Replace-in-place toast — use a stable `id` to dedupe rapid-fire updates
 * (e.g., toggling Brand voice archetype repeatedly). Sonner replaces the
 * existing toast at that id rather than stacking.
 */
export function toastInPlace(
  id: string,
  message: string,
  description?: string,
  variant: 'success' | 'info' | 'warning' | 'error' = 'success',
) {
  if (variant === 'error') {
    const plain = plainToastText(message, description);
    toast.error(plain.message, { id, description: plain.description });
    return;
  }
  toast[variant](message, { id, description });
}
